/* eslint-disable @typescript-eslint/no-non-null-assertion */
import styled from "styled-components";
const partnerId = process.env.REACT_APP_SITE_ID!;
// theme is now fully typed
export const LogoWrapper = styled.div`
  width: ${partnerId === "POUPAS" ? "220px" : "auto"};
  img {
    height: ${partnerId === "POUPAS" ? "60px" : "50px"};
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }
`;
